"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
/**
 * Shared login page for Electron/desktop apps (content-creator, desktop-admin).
 * White card on colored background; validates non-empty email/password, calls login(), shows error on throw.
 */
const AppLoginPage = ({ title, subtitle, login, emptyMessage = 'Please enter both email and password', backgroundColor = '#e8f5e9', buttonColor = '#f97316', }) => {
    const [email, setEmail] = (0, react_1.useState)('');
    const [password, setPassword] = (0, react_1.useState)('');
    const [error, setError] = (0, react_1.useState)('');
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const handleSubmit = async (e) => {
        e.preventDefault();
        const trimmedEmail = email.trim();
        const trimmedPassword = password.trim();
        if (!trimmedEmail || !trimmedPassword) {
            setError(emptyMessage);
            return;
        }
        setError('');
        setIsLoading(true);
        try {
            await login(trimmedEmail, trimmedPassword);
        }
        catch (err) {
            setError(err instanceof Error ? err.message : 'Login failed');
        }
        finally {
            setIsLoading(false);
        }
    };
    return ((0, jsx_runtime_1.jsx)("div", { style: {
            width: '100vw',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: backgroundColor,
        }, children: (0, jsx_runtime_1.jsxs)("div", { style: {
                background: 'white',
                padding: '2rem 3rem',
                borderRadius: 12,
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                width: '100%',
                maxWidth: 400,
            }, children: [(0, jsx_runtime_1.jsxs)("div", { style: { textAlign: 'center', marginBottom: '2rem' }, children: [(0, jsx_runtime_1.jsx)("h1", { style: { margin: 0, fontSize: 28, fontWeight: 600, color: '#333', marginBottom: '0.5rem' }, children: title }), (0, jsx_runtime_1.jsx)("p", { style: { margin: 0, color: '#666', fontSize: 14 }, children: subtitle })] }), (0, jsx_runtime_1.jsxs)("form", { onSubmit: handleSubmit, children: [error && ((0, jsx_runtime_1.jsx)("div", { style: {
                                background: '#fee2e2',
                                border: '1px solid #fca5a5',
                                color: '#dc2626',
                                padding: '0.75rem',
                                borderRadius: 6,
                                marginBottom: '1rem',
                                fontSize: 14,
                            }, children: error })), (0, jsx_runtime_1.jsxs)("div", { style: { marginBottom: '1.5rem' }, children: [(0, jsx_runtime_1.jsx)("label", { style: { display: 'block', marginBottom: '0.5rem', fontWeight: 500, color: '#333', fontSize: 14 }, children: "Email" }), (0, jsx_runtime_1.jsx)("input", { type: "email", value: email, onChange: (e) => setEmail(e.target.value), disabled: isLoading, style: {
                                        width: '100%',
                                        padding: '0.75rem',
                                        border: '1px solid #d1d5db',
                                        borderRadius: 6,
                                        fontSize: 14,
                                        boxSizing: 'border-box',
                                        background: isLoading ? '#f3f4f6' : 'white',
                                        color: '#333',
                                    }, placeholder: "your@email.com", autoComplete: "email" })] }), (0, jsx_runtime_1.jsxs)("div", { style: { marginBottom: '1.5rem' }, children: [(0, jsx_runtime_1.jsx)("label", { style: { display: 'block', marginBottom: '0.5rem', fontWeight: 500, color: '#333', fontSize: 14 }, children: "Password" }), (0, jsx_runtime_1.jsx)("input", { type: "password", value: password, onChange: (e) => setPassword(e.target.value), disabled: isLoading, style: {
                                        width: '100%',
                                        padding: '0.75rem',
                                        border: '1px solid #d1d5db',
                                        borderRadius: 6,
                                        fontSize: 14,
                                        boxSizing: 'border-box',
                                        background: isLoading ? '#f3f4f6' : 'white',
                                        color: '#333',
                                    }, placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022", autoComplete: "current-password" })] }), (0, jsx_runtime_1.jsx)("button", { type: "submit", disabled: isLoading, style: {
                                width: '100%',
                                padding: '0.75rem',
                                background: isLoading ? '#9ca3af' : buttonColor,
                                color: 'white',
                                border: 'none',
                                borderRadius: 6,
                                fontSize: 16,
                                fontWeight: 600,
                                cursor: isLoading ? 'not-allowed' : 'pointer',
                                transition: 'background 0.2s',
                            }, children: isLoading ? 'Signing in...' : 'Sign In' })] })] }) }));
};
exports.default = AppLoginPage;
